import React from 'react';
import * as S from './style'
import Paper from '@material-ui/core/Paper';
import numeral from 'numeral';
import TextField from '@material-ui/core/TextField';
import {TreeDataState, CustomTreeData, EditingState} from '@devexpress/dx-react-grid'
import {Add16, Undo16, Calendar16} from '@carbon/icons-react'
import {
    Grid,
    Table,
    TableHeaderRow,
    TableTreeColumn,
    TableEditRow,
    TableFixedColumns,
    TableInlineCellEditing, VirtualTable,
} from '@devexpress/dx-react-grid-material-ui'
import {TemplateConnector} from "@devexpress/dx-react-core";
import {useTableConfig} from './hooks';
import TableRow from './components/TableRow'
import TableCell from './components/TableCell'
import {TableHeaderContent} from './components/TableHeader'
import Popup from './components/PopupEditing';
import {Button, TableToolbar, TableToolbarContent} from "carbon-components-react";

const CustomTable = ({
                         headerInformation = null,
                         columns,
                         rowsData,
                         unmutableRows,
                         editable = false,
                         createUser = false,
                         refreshData = null,
                         undoData = null,
                         callCreate = null
                     }) => {
    const {
        setIsEditing,
        isEditing,
        tableColumnExtensions,
        getChildRows,
        rows,
        unmuRows,
        commitChanges,
        getRowId,
        leftColumns,
        changeColumns,
        editedRows,
        setEditedRows,
        editingRows,
        editingColumns,
        setEditingRows,
        showEditingPopup,
        setShowEditingPopup,
        currentColumnEdition,
        setCurrentColumnEdition,
        setValues,
        inputEditings,
        setInputEditings
    } = useTableConfig({rowsData, unmutableRows, columns, editable})

    const editColumn = (column) => {
        setShowEditingPopup(true)
        setCurrentColumnEdition(column)
    }
    const changeFunction = (textValue, stopEditCells, row, column) => {
        if (textValue === '') {
            let object = rows.find(x => x.id === inputEditings[0].rowId) // acha a linha pra edição
            object[column.name] = (0).toFixed(2)
            // stopEditCells({editingCells: [{rowId: row.id, columnName: column.name}]})
        }
    }


    function converteMoedaFloat(valor) {
        if (valor === "") {
            valor = 0;
        } else {
            const commas = [...valor].reduce((a, c) => c === ',' ? ++a : a, 0);
            const dot = [...valor].reduce((a, c) => c === '.' ? ++a : a, 0);

            if (commas === 1 && dot >= 1) {
                valor = valor.replace(/[.]/g, "");
                valor = valor.replace(",", ".");
                valor = parseFloat(valor);
            } else if (commas === 1 && dot === 0) {
                valor = valor.replace(",", ".");
                valor = parseFloat(valor);
            } else if (commas === 0 && dot === 1) {
                valor = parseFloat(valor);
            } else {
                valor = valor.replace(/[.]/g, "");
                valor = valor.replace(",", ".");
                valor = parseFloat(valor);
            }
        }
        return valor;

    }

    const shareRows = (textValue, stopEditCells, row, column) => {
        if (textValue !== '') {
            const scapedText = escape(textValue)
            if (scapedText.split('%09').length > 1) {
                let object = rows.find(x => x.id === inputEditings[0].rowId) // acha a linha pra edição
                const startPoint = Object.keys(object).findIndex((e) => e === inputEditings[0].columnName);
                const filtered = Object.keys(object).filter(
                    (element, index) => index >= startPoint
                );

                let textIndex = 0;
                //  console.log(filtered);
                filtered.forEach((element) => {
                    if (scapedText.split('%09')[textIndex]) {
                        object[element] = numeral(converteMoedaFloat(decodeURIComponent(scapedText.split('%09')[textIndex]))).format('0.00')//percorre os items do objeto setando os novos valores
                        //  console.log(object[element]);
                        object["editado"] = true //percorre os items do objeto setando os novos valores
                        textIndex++
                    }
                });

                stopEditCells({editingCells: [{rowId: row.id, columnName: column.name}]})
            } else {
                let object = rows.find(x => x.id === inputEditings[0].rowId) // acha a linha pra edição

                object[column.name] = numeral(converteMoedaFloat(textValue)).format('0.00')

                //object[column.name] = numeral(textValue).format('0.00')
                object["editado"] = true
                stopEditCells({editingCells: [{rowId: row.id, columnName: column.name}]})
            }
        } else {
            if (textValue.length != 0)
                stopEditCells({editingCells: [{rowId: row.id, columnName: column.name}]})
        }
    }

    return (
        <S.Container>
            {
                headerInformation && (
                    <S.HeaderWrapper>
                        <S.HeaderTitle>{headerInformation.title}</S.HeaderTitle>
                        <S.DescriptionWrapper>
                            <Calendar16/>
                            {headerInformation.date &&
                                <S.DescriptionLabel>{headerInformation.date}</S.DescriptionLabel>}

                        </S.DescriptionWrapper>
                    </S.HeaderWrapper>
                )
            }

            <Paper>
                <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}>
                    <TreeDataState/>
                    <CustomTreeData getChildRows={getChildRows}/>
                    <EditingState
                        rowChanges={editedRows}
                        onRowChangesChange={setEditedRows}
                        onEditingRowIdsChange={setEditingRows}
                        editingRowIds={isEditing ? editingRows : []}
                        columnExtensions={editingColumns}
                        onCommitChanges={commitChanges}
                        onEditingCellsChange={setInputEditings}
                    />
                    <Table columnExtensions={tableColumnExtensions} rowComponent={TableRow} cellComponent={TableCell}/>
                    <VirtualTable
                        rowComponent={TableRow}
                        cellComponent={TableCell}
                        columnExtensions={tableColumnExtensions}
                        height="500px"
                    />
                    <TableHeaderRow
                        contentComponent={(e) => TableHeaderContent(e, changeColumns, leftColumns, editColumn, editable, editingColumns)}/>

                    {
                        editable && (
                            <TemplateConnector>
                                {(getters, {stopEditCells, startEditCells}) => (
                                    <TableInlineCellEditing
                                        cellComponent={({row, column}) => {
                                            if (column.editable && row.type == 'row') {
                                                return (
                                                    <td>
                                                        <TextField id={row.id + column.name} autoFocus={true}
                                                                   onKeyDown={(e) => {
                                                                       if (e.key === 'Tab') {
                                                                           e.preventDefault()
                                                                           const columnIndex = columns.findIndex(c => c.name === column.name)
                                                                           shareRows(e.target.value, stopEditCells, row, column)
                                                                           if (columns[columnIndex + 1] !== undefined) {
                                                                               startEditCells({
                                                                                   editingCells: [{
                                                                                       rowId: row.id,
                                                                                       columnName: columns[columnIndex + 1].name
                                                                                   }]
                                                                               })
                                                                           }
                                                                       }
                                                                   }}
                                                                   type="number"
                                                                   defaultValue={row[column.name]}
                                                                   fullWidth
                                                                   label="Digite ou cole os valores"
                                                                   onChange={(e) => changeFunction(e.target.value, stopEditCells, row, column)}
                                                                   onBlur={(e) => shareRows(e.target.value, stopEditCells, row, column)}
                                                                   onPaste={(e) => shareRows(e.clipboardData.getData('text/plain'), stopEditCells, row, column)}
                                                                   variant="standard"/>
                                                    </td>
                                                )
                                            } else {
                                                stopEditCells({
                                                    editingCells: [{
                                                        rowId: row.id,
                                                        columnName: column.name
                                                    }]
                                                })
                                                return <> </>
                                            }
                                        }
                                        }
                                        startEditAction={'doubleClick'}
                                    />
                                )}
                            </TemplateConnector>
                        )
                    }
                    <TableEditRow/>


                    <TableTreeColumn for={columns[0].name}/>
                    <TableFixedColumns leftColumns={leftColumns}/>
                    {editable && (
                        <S.ButtonWrapper>
                            <S.ButtonContainer onClick={() => undoData()}><Undo16/></S.ButtonContainer>
                            <TemplateConnector>
                                {(getters, {commitChangedRows}) => (
                                    <S.ButtonContainer onClick={() => {
                                        if (isEditing) {
                                            setIsEditing(!isEditing)
                                        }
                                        commitChangedRows({rowIds: editingRows});
                                        refreshData(unmuRows, rows)
                                    }
                                    }
                                                       saveButton>Salvar</S.ButtonContainer>
                                )}
                            </TemplateConnector>
                        </S.ButtonWrapper>
                    )}
                    {createUser && (
                        <div>
                            <TableToolbar>
                                <TableToolbarContent>
                                    <Button
                                        onClick={() => callCreate()}
                                        tabIndex={0}
                                        size="default"
                                        kind="primary"
                                        renderIcon={Add16}
                                        iconDescription="Criar usuário"
                                    >
                                        Criar usuário
                                    </Button>
                                </TableToolbarContent>
                            </TableToolbar>
                        </div>
                    )}
                </Grid>
            </Paper>
            <Popup
                open={showEditingPopup}
                onApplyChanges={setValues}
                setShowEditingPopup={setShowEditingPopup}
                column={currentColumnEdition}
            />
        </S.Container>
    )
};

export default CustomTable
